// extracted by mini-css-extract-plugin
module.exports = {"activity":"Activity_activity__3j7cK","top":"Activity_top__1jTK1","breadcrumb":"Activity_breadcrumb__6kf5N"};